import { cn } from '@/common/lib/cn/cn'
import { formatScoreValue, getProductScoreTier, productScorePillClass } from '../lib/scoreColors'

type CompanyStatsProductScorePillProps = {
    score: number
    maxScore: number
}

export const CompanyStatsProductScorePill = ({ score, maxScore }: CompanyStatsProductScorePillProps) => {
    const tier = getProductScoreTier(score)

    return (
        <span
            className={cn(
                'shrink-0 whitespace-nowrap rounded-md px-2 py-1 text-xs font-medium tabular-nums',
                productScorePillClass[tier]
            )}
        >
            {formatScoreValue(score)}
            {'\u00A0'}/{'\u00A0'}
            {formatScoreValue(maxScore)}
        </span>
    )
}
